import { createFileRoute } from '@tanstack/react-router';

import { Rocket } from '@mint-lib/icons';
import { buildGuards, hasPermission, some } from '@mint-lib/routing-guards';
import { MediaPlan } from '@mint-sdk/api-media-plan';
import { z } from 'zod';

// TODO(STZF-23): fix guard duplication with sidebar in permissions refactoring
const sidebarGuard = buildGuards(
  some(
    hasPermission('campaignPlanningFeature:view'),
    hasPermission('campaignSettingsFeature:view'),
    hasPermission('campaignStrategyFeature:view'),
    hasPermission('campaignTraffickingFeature:view'),
  ),
);

export const Route = createFileRoute('/_secured/campaigns/')({
  staticData: {
    commandMeta: ({ t, check }) => {
      if (!check(sidebarGuard)) {
        return;
      }

      return {
        title: t('My plans'),
        keywords: [t('campaigns'), t('media plans')],
        icon: Rocket,
      };
    },
  },
  validateSearch: z.object({
    from: z.string().optional(),
    to: z.string().optional(),
    search: z.string().optional(),
    page: z.coerce.number().optional(),
    size: z.coerce.number().optional(),
    clients: z.array(z.coerce.number()).optional(),
    currency: z.string().optional(),
  }),

  async loader({ context }) {
    const i18n = await context.getInstance('i18n', '@mint/routing');
    const isCampaignsV2Enabled = await context.isFlagEnabled(
      '@mint/arm',
      'campaignsV2',
    );

    if (!isCampaignsV2Enabled) {
      await context.getInstance('i18n', '@myn/campaigns');
      return {
        title: i18n.t('My Campaigns | MINT'),
      };
    }

    await Promise.all([
      context.getInstance('i18n', '@myn/plans'),
      context.getInstance('i18n', '@mint-lib/formatting-hooks'),
    ]);
    context.prefetchQuery({
      ...MediaPlan.getColumnListQueryOptions({}),
      staleTime: 1000 * 30, // 30 seconds
    });
    context.prefetchQuery({
      ...MediaPlan.getUserSettingsQueryOptions({}),
      staleTime: Infinity,
    });

    return { title: i18n.t('My Plans | MINT') };
  },

  head({ loaderData }) {
    const title = loaderData?.title;
    return {
      meta: [
        {
          title,
        },
      ],
    };
  },
});
